/**
 * Model to support Clipboard funcionality.
 *
 * this is used via url appending /data=jsonObject to the url
 *
 * ex: a field that acts as a link to create an instance with auto pasted fields Name and Nif would be like:
 *
 * $link $auto.text(NomeOrigem,NifOrigem).join('/debug.html#/instance/create/75/data={"opts":{"auto-paste-if-empty":true, "readonly-on-paste": false},"fields":[{"value":"',NomeOrigem,'","fieldDefinition":{"name":"Nome"}},{"value":"',NifOrigem,'","fieldDefinition":{"name":"Nif"}}]}')
 *
 *
 * Also Note that the subobj opts is optional.
 */
var ClipboardM = function() {
    this._fieldsByDef = {};
    this._opts = {};
};

/*
 * Expects an obj like:
 * {
        "opts": {
            "auto-paste-if-empty": true
            "readonly-on-paste": true
        },
        "fields": [
                 { "value": "o nome", "fieldDefinition": { "name": "Nome" } },
                 { "value": "o nif", "fieldDefinition": { "name": "Nif" } }
        ]
    }
 */
ClipboardM.prototype.set = function(contents){
    var _this = this;

    if(!contents) return;

    this._opts = contents.opts || {};

    if(contents.fields){
        _this._fieldsByDef = {};
        contents.fields.forEach(function(field){
            //this obviously doesn't support multiple fields with the same name
            _this._fieldsByDef[field.fieldDefinition.name] = field;
        });
    }
};

ClipboardM.prototype.getFor = function(def) {
    return this._fieldsByDef[def] ? this._fieldsByDef[def].value : null;
};

ClipboardM.prototype.autoPasteIfEmpty = function() {
    return this._opts["auto-paste-if-empty"] == true;
};

ClipboardM.prototype.setReadonlyOnPaste = function() {
    return this._opts["readonly-on-paste"] == true;
}

ClipboardM.prototype.buildClipboardObject = function(fieldValuePairsArray) {
    const buildClipboardFieldFn = this._buildClipboardField;

    return {
        "opts": {"auto-paste-if-empty": true},
        "fields": fieldValuePairsArray.map(function(pair) {
            return buildClipboardFieldFn(pair.targetField, pair.value);
        })
    };
};

ClipboardM.prototype._buildClipboardField = function(field, value) {
    let _val = value || "";

    if (typeof value === 'string') {
        //before encoding we need to stringify the value so the json object can be decoded properly by the clipboard
        //(escape the " and the \n, etc..)
        // We also need to take out the enclosing "" that the JSON.stringify puts here because the encoding that is
        //done on top of this would disguise the quotes and we end up with a wrong json with double quotes {"value":""x\"xx""}
        _val = JSON.stringify(value).slice(1, -1);
    }

    return {
        "value": encodeURIComponent(_val),
        "fieldDefinition": {"name": encodeURIComponent(field)}
    };
};

export default ClipboardM;
